<template>
  <validation-observer
    v-if="!isAdditional"
    v-show="isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      id="residential-status"
      :validated="formObserver.validated"
      v-bind="observer"
    >
      <!-- RESIDENTIAL STATUS -->
      <form-row
        :label="`What is ${isAdditional ? 'their' : 'your'} residential status?`"
        :error="formObserver.validated && observer.invalid"
      >
        <template slot="helpText">
          <div class="d-flex align-start">
            <v-icon
              color="primary"
              class="mr-4"
            >
              mdi-credit-card-outline
            </v-icon>
            <p>
              <strong>Price sensitive question</strong><br>
              Some of our insurance providers may offer you a discount if you are a home owner.
            </p>
          </div>
        </template>
        <validation-provider
          v-slot="{ failed }"
          :vid="`${stepId}_residential-status`"
          name="Residential Status"
          rules="required"
        >
          <radio
            v-model="questionData.residentialStatus"
            :name="`${stepId}.residential-status`"
            :data-test="snakeCase(questionFields.residentialStatus)"
            :items="driverResidentialStatus"
            :error="failed"
            :error-messages="failed ?
              [`Please select ${isAdditional ? 'their' : 'your'} residential status.`] :
              []"
            column
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from './Base';

export default {
  name: 'question-residential-status',
  extends: QuestionBase,
  data () {
    return {
      fields: ['residentialStatus'],
    };
  },
  computed: {
    driverResidentialStatus () {
      return this.helpers.createOptions({ source: this.constants.DRIVER_RESIDENTIAL_STATUS });
    },
  },
};
</script>
